import React, { useState, useEffect, useContext, useRef } from "react";
import { Fragment } from "react";
import { ReactReduxContext } from 'react-redux';
import { Route, Redirect, useHistory } from "react-router-dom";
import Footer from "./common/Footer";
import {
  EDITOR_LINK,
  HEADING_LINK,
  WORKHISTORY_LINK,
  EDUCATION_LINK,
  SKILLS_LINK,
  SUMMARY_LINK,
  FINALIZE_LINK,
  ADDITONAL_PREDEFINE_SECTIONS,
  FINAL_RESUME,
  CUSTOM_SECTION_LINK,
  DASHBOARD_LINK,
  BREADCRUMB_LINKS,
  EDITOR_ALL_INONE_LINK,
  ADDITIONAL_SECTIONS_LINK,
  POPUP_TYPES,
  REARRANGE_LINK,
  WORKHISTORY_TIPS_LINK,
  EDUCATION_TIPS_LINK,
  SKILL_TIPS_LINK,
  SUMMARY_TIPS_LINK,
  QUICK_EDITOR,
} from '../constants/constants';

import EditorHeading from './EditorHeading';
import RightSection from "./editor/RightSection";
import BreadcrumComponent from "./BreadcrumbComponent";
import Layout from "./common/Layout";
//Core sections
import EditorWorkHistory from './EditorWorkHistory';
import EditorEducationHistory from './EditorEducationHistory';
import EditorSkills from './EditorSkills';
import EditorSummary from './EditorSummary';

// import ConfirmationBox from "./common/ConfirmationBox";
import WpAPI from "../WpApi";
import SignUpPopup from "./user/SignUpPopup";
import LeftPanel from "./common/LeftPanel";
import EditorAccordianAllSections from "./EditorAccordianAllSections";
import AdditionalSections from "./AdditionalSections";
import { ResumeProvider } from "../context/ResumeContext";
// import Header from "../containers/HeaderContainer";
//import HeaderLogo from "./common/HeaderLogo";
//import Navbar from './common/HeaderNavbar';
//import switchEditor from "./common/SwitchEditor";
import '../assets/scss/app/blocks/traditional-editor.scss';
//import { PopupProvider } from "../context/PopupContext";
//import Version from "../Version";
import { usePopup } from "../context/PopupContext";
import Splash from "./common/Splash";
import EditorSectionRearrange from "./EditorSectionRearrange";
import EditorSectionsTips from "./EditorSectionsTips";

// const Accomplishments = React.lazy(() => import("./Accomplishments"));

const Editor = (props) => {
  const { store } = useContext(ReactReduxContext);
  const popupbox = usePopup();
  // const [showBack, setShowBack] = useState(false);
  const [showLoginPopUp, setShowLoginPopUp] = useState(false);
  // const [loader, setLoader] = useState(false);
  const [redirect, setRedirect] = useState(false);
  // const [sectionSkipped, setsectionSkipped] = useState(false);
  // const [customBox, setCustomBox] = useState(false);
  const [currentResume, setCurrentResume] = useState('');
  // const [showAddSkip, setShowAddSkip] = useState(false);
  const [showEditorList, setShowEditorList] = useState(false);
  const [switchToEditorURL, setSwitchToEditorURL] = useState('')
  const [spinner, setSpinner] = useState(false)

  const switchEditor = (v) => {

    if (props.resume.active_editor !== v) {
      v == 'traditional' && setSwitchToEditorURL(() => {
        const ct = props.resume.current_tab;
        return (BREADCRUMB_LINKS.hasOwnProperty(ct) && ct != 'summary') ? BREADCRUMB_LINKS[ct].link : BREADCRUMB_LINKS['heading'].link;
      });
      v == 'allinone' && (setSwitchToEditorURL(QUICK_EDITOR), props.handlers.nuteralizeNextClick({ scroll2_active_section: true }));
    }
    props.handlers.updateResumePreview({ active_editor: v }, true);

    //props.handlers.onsaveResume();
    setTimeout(() => { setShowEditorList(false); }, 50)
  }

  useEffect(() => {
    popupbox.configurePopup(POPUP_TYPES);
  }, []);

  useEffect(() => {
    if (props.resume.hasOwnProperty('created_date') && props.resume.enabled_tabs.length > 1 && !props.resume.created_date.length) setRedirect(true)
    if (currentResume === '') {
      let cr = WpAPI.getCurrentResume();
      setCurrentResume(cr);
    }
    //Set to avoid further redirect
    setSwitchToEditorURL('')
    // setShowAddSkip([WORKHISTORY_LINK, EDUCATION_LINK, SKILLS_LINK, SUMMARY_LINK].includes(location.pathname));
  });

  {/** 
    * START
    * Commented out the below code to remove the undo/redo feature from the all-in-one editor.
    * Note: The undo/redo feature is implemented on the all-in-one editor only.
    * Ticket: https://gitlab.dailyrssmail.com/growthlabs/resumebuilder-app/-/issues/540
    * Date: 2023-12-24
    * 
  */}
  // let i = 0;

  // const versioning = () => {
  //   //Version.addNew(props);
  //   if(i == 0){localStorage.setItem('localState', JSON.stringify(props)); i++;}
  //   let versionDifference = Version.validateNewRevision(props);
  //   if(versionDifference !== 0){
  //       Version.addNew(props);
  //   }
  //   setTimeout(() => versioning(), 3000);
  // }

  // const currRef = useRef();
  // const ddRef = useRef();
  // useEffect(() => {
  //   if(!currRef.current){
  //     Version.flush();
  //     currRef.current = true;
  //   }
  //   if (props.currentResume) {
  //     versioning();
  //   }
  // }, [props.currentResume])
  {/**
    * END
  */}

  // const onClickOutside = (e) => {
  //   if (e.target.className !== '' || e.target.className == 'header-main traditional-main') {
  //     setShowEditorList(false);
  //   }
  // }
  //useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (ddRef.current && !ddRef.current.contains(event.target)) {
  //       onClickOutside && onClickOutside(event);
  //     }
  //   };
  //   document.addEventListener('click', handleClickOutside, true);
  //   return () => {
  //     document.removeEventListener('click', handleClickOutside, true);
  //   };
  // }, [onClickOutside]);

  if (redirect) return <Redirect to={DASHBOARD_LINK} />
  if (switchToEditorURL.length) return <Redirect to={switchToEditorURL} />
  
  return (<>
    {props.currentResume != undefined && <ResumeProvider {...props}>
      <Fragment>
        {/* <Header 
          editorType={props.resume.active_editor}
          saveResume={props.handlers.onsaveResume}
          resumeLoaded={props.currentResume != undefined}
          showSplash={true}
       /> */}
         <Route exact path={WORKHISTORY_TIPS_LINK}>
          {/*  Layout is messed */}
          <Layout
            left={<EditorSectionsTips splash={<Splash />}  section={'work_history'}  nextSection={WORKHISTORY_LINK} previousSection={HEADING_LINK}/>}
            //right={<RightSection current_tab={props.current_tab} resume={props.resume} />}
            showLoginPopUp={showLoginPopUp}
            setShowLoginPopUp={(showLoginPopUp) => { setShowLoginPopUp(showLoginPopUp) }}
            breadcrumb={!props.resume.enabled_tabs.includes('completed') ? <BreadcrumComponent enabled={props.resume.enabled_tabs} /> : false}
          />
        </Route>
        <Route exact path={EDUCATION_TIPS_LINK}>
          {/*  Layout is messed */}
          <Layout
            left={<EditorSectionsTips splash={<Splash />}  section={'education_history'}  nextSection={EDUCATION_LINK} previousSection={WORKHISTORY_LINK}/>}
            //right={<RightSection current_tab={props.current_tab} resume={props.resume} />}
            showLoginPopUp={showLoginPopUp}
            setShowLoginPopUp={(showLoginPopUp) => { setShowLoginPopUp(showLoginPopUp) }}
            breadcrumb={!props.resume.enabled_tabs.includes('completed') ? <BreadcrumComponent enabled={props.resume.enabled_tabs} /> : false}
          />
        </Route>
        <Route exact path={SKILL_TIPS_LINK}>
          {/*  Layout is messed */}
          <Layout
            left={<EditorSectionsTips splash={<Splash />}  section={'skills'}  nextSection={SKILLS_LINK} previousSection={EDUCATION_LINK}/>}
            //right={<RightSection current_tab={props.current_tab} resume={props.resume} />}
            showLoginPopUp={showLoginPopUp}
            setShowLoginPopUp={(showLoginPopUp) => { setShowLoginPopUp(showLoginPopUp) }}
            breadcrumb={!props.resume.enabled_tabs.includes('completed') ? <BreadcrumComponent enabled={props.resume.enabled_tabs} /> : false}
          />
        </Route>
        <Route exact path={SUMMARY_TIPS_LINK}>
          {/*  Layout is messed */}
          <Layout
            left={<EditorSectionsTips splash={<Splash />} section={'summary'}  nextSection={SUMMARY_LINK} previousSection={ADDITIONAL_SECTIONS_LINK}/>}
            //right={<RightSection current_tab={props.current_tab} resume={props.resume} />}
            showLoginPopUp={showLoginPopUp}
            setShowLoginPopUp={(showLoginPopUp) => { setShowLoginPopUp(showLoginPopUp) }}
            breadcrumb={!props.resume.enabled_tabs.includes('completed') ? <BreadcrumComponent enabled={props.resume.enabled_tabs} /> : false}
          />
        </Route>
        <Route exact path={EDITOR_LINK} >
          <Redirect to='' />
        </Route>
        <Route exact path={EDITOR_ALL_INONE_LINK}>
          <EditorAccordianAllSections
            leftPanel={<LeftPanel />}
          />
        </Route>
        <Route exact path={ADDITIONAL_SECTIONS_LINK}>
          <Layout
            left={<AdditionalSections splash={<Splash />} />}
            showLoginPopUp={showLoginPopUp}
            setShowLoginPopUp={(showLoginPopUp) => { setShowLoginPopUp(showLoginPopUp) }}
            right={<RightSection current_tab={props.current_tab} resume={props.resume} />}
          />
        </Route>
        <Route exact path={REARRANGE_LINK}> <EditorSectionRearrange /> </Route>
        <Route exact path={HEADING_LINK}>
          <Layout
            left={<EditorHeading splash={<Splash />} />}
            //right={<RightSection current_tab={props.current_tab} resume={props.resume} />}
            showLoginPopUp={showLoginPopUp}
            setShowLoginPopUp={(showLoginPopUp) => { setShowLoginPopUp(showLoginPopUp) }}
            breadcrumb={!props.resume.enabled_tabs.includes('completed') ? <BreadcrumComponent enabled={props.resume.enabled_tabs} /> : false}
          />
        </Route>
        <Route exact path={WORKHISTORY_LINK}>
          <Layout
            left={<EditorWorkHistory splash={<Splash />} />}
            //right={<RightSection current_tab={props.current_tab} resume={props.resume} />}
            showLoginPopUp={showLoginPopUp}
            setShowLoginPopUp={(showLoginPopUp) => { setShowLoginPopUp(showLoginPopUp) }}
            breadcrumb={!props.resume.enabled_tabs.includes('completed') ? <BreadcrumComponent enabled={props.resume.enabled_tabs} /> : false}
          />
        </Route>
        <Route exact path={EDUCATION_LINK}>
          <Layout
            left={<EditorEducationHistory splash={<Splash />} />}
            //right={<RightSection current_tab={props.current_tab} resume={props.resume} />}
            showLoginPopUp={showLoginPopUp}
            setShowLoginPopUp={(showLoginPopUp) => { setShowLoginPopUp(showLoginPopUp) }}
            breadcrumb={!props.resume.enabled_tabs.includes('completed') ? <BreadcrumComponent enabled={props.resume.enabled_tabs} /> : false}
          />
        </Route>
        <Route exact path={SKILLS_LINK}>
          {/*  Layout is messed */}
          <Layout
            left={<EditorSkills splash={<Splash />} />}
            //right={<RightSection current_tab={props.current_tab} resume={props.resume} />}
            showLoginPopUp={showLoginPopUp}
            setShowLoginPopUp={(showLoginPopUp) => { setShowLoginPopUp(showLoginPopUp) }}
            breadcrumb={!props.resume.enabled_tabs.includes('completed') ? <BreadcrumComponent enabled={props.resume.enabled_tabs} /> : false}
          />
          </Route>
        <Route exact path={SUMMARY_LINK}>
          {/*  Layout is messed */}
          <Layout
            left={<EditorSummary splash={<Splash />}  />}
            //right={<RightSection current_tab={props.current_tab} resume={props.resume} />}
            showLoginPopUp={showLoginPopUp}
            setShowLoginPopUp={(showLoginPopUp) => { setShowLoginPopUp(showLoginPopUp) }}
            breadcrumb={!props.resume.enabled_tabs.includes('completed') ? <BreadcrumComponent enabled={props.resume.enabled_tabs} /> : false}
          />
        </Route>
        <Footer className="edit-editor-footer" />
      </Fragment>
      {showLoginPopUp ? <SignUpPopup setShowLoginPopUp={(c) => { setShowLoginPopUp(c) }} /> : ''}
      {/* {customBox && <ConfirmationBox
        label={props.skip_label}
        setCustomBox={(customBox) => { setCustomBox(customBox) }}
        handler={(confirmed) => { isConfirmed(confirmed) }} />} */}
    </ResumeProvider>}
  </>);
};
export default Editor;
